module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fR00k"))).then(() => parcelRequire('d0iPb'));